"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const icons = {
    xs: {
        width: '13px',
        height: '13px',
    },
    sm: {
        width: '17px',
        height: '17px',
    },
    md: {
        width: '20px',
        height: '20px',
    },
    xmd: {
        width: '22px',
        height: '22px',
    },
    lg: {
        width: '24px',
        height: '24px',
    },
    xlg: {
        width: '28px',
        height: '28px',
    },
    xxlg: {
        width: '40px',
        height: '40px',
    },
};
exports.default = icons;
//# sourceMappingURL=icons.js.map